import { FC } from "react";

import PasswordLogin from "../privatperson/PasswordLogin";
import styles from "./OAuth.module.less";

export const OAuthPasswordAuthorize: FC = () => {
  return (
    <article>
      <div className={styles.outerContainer}>
        <div className={styles.loginContent}>
          <PasswordLogin />
        </div>
      </div>
    </article>
  );
};
